import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../core/auth/auth.service';
import { TempStateService } from '../../core/navigation/tempState.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { TokenDTO } from 'src/app/models/token-dto.model';
import { ApiService } from 'src/app/services/http/api.service';
import Validation from 'src/app/utils/validation';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogService } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html'
})
export class PasswordComponent implements OnInit, AfterViewInit {
  @ViewChild("password") passwordInput: TextBoxComponent | undefined;
  @ViewChild("passwordRewrite") passwordInputRe: TextBoxComponent | undefined;
  formGroup: FormGroup;
  isLoadingResults: boolean = false;
  public errorMessage: string = '';
  returnUrl: string = '';
  public guid: string = '';
  public isPasswordVisible: boolean = false;
  public isPasswordRewriteVisible: boolean = false;
  passwordicon = 'textbox-hidden';
  isLinkExpirado: boolean = false;
  mostraForm: boolean = false;
  mensagemErro: string = '';
  constructor(
    private auth: AuthService,
    private router: Router,
    private stateService: TempStateService,
    private api: ApiService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private dialogService: DialogService
  ) {
    this.formGroup = new FormGroup(
      {
        password: new FormControl(null, Validators.required),
        passwordRewrite: new FormControl(null, Validators.required)
      },
      {
        validators: [Validation.match('password', 'passwordRewrite')]
      }
    );

  }

  ngAfterViewInit() {
    this.hidePassword();
    this.hidePasswordRe();
    this.returnUrl = this.stateService.oldUrl || '/';
    this.guid = this.router.routerState.snapshot.root.queryParams['guid'];
    this.verificaLink();
  }

  ngOnInit(): void {

  }

  loginPage() {
    this.router.navigateByUrl('login');
  }

  initForm() {
    this.formGroup = new FormGroup({
      password: new FormControl(null, Validators.required),
      passwordRewrite: new FormControl(null, Validators.required)
    });
  }

  onSubmit() {
    if (this.formGroup.dirty && this.formGroup.valid) {
      const dto =
        {
          guid: this.guid,
          Password: this.formGroup.controls['password'].value
        } as TokenDTO;
      this.api
        .postRequest<BaseHttpResponse<TokenDTO>>(
          "Utilizador/UpdatePassword",
          dto
        )
        .then((data) => {
          if (data.ok) {
            this.notificationService.show({
              content: 'Password alterada com sucesso',
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'success', icon: true },
              hideAfter: 4000
            });
            this.isLoadingResults = true;
          } else {
            this.notificationService.show({
              content: data.message,
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'bottom' },
              type: { style: 'error', icon: true },
              hideAfter: 4000
            });
          }
        })
        .catch((err) => {
          this.notificationService.show({
            content: 'internal server error',
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'top' },
            type: { style: 'error', icon: true },
            hideAfter: 2000
          });


        });
    } else {
    }
  }

  public verificaLink() {
    this.api
      .getRequest<BaseHttpResult>("Utilizador/VerificaLinkExpirado?guid=" + this.guid)
      .then((data) => {
        if (this.isLinkExpirado = !data.ok) {
          this.mensagemErro = data.message;
        }
        else {
          this.mostraForm = true;
          this.hidePassword();
          this.hidePasswordRe();
        }
      })
      .catch((err) => { });
  }

  selectedChange() {
    if (this.isPasswordVisible == true)
      this.hidePassword();
    else
      this.showPassword();
  }

  selectedChangeRe() {
    if (this.isPasswordRewriteVisible == true)
      this.hidePasswordRe();
    else
      this.showPasswordRe();
  }

  showPassword() {
    if (this.passwordInput) {
      this.passwordInput.input.nativeElement.type = "text";
      this.isPasswordVisible = true;
      this.passwordicon = 'password';
    }
  }

  hidePassword() {
    if (this.passwordInput) {
      this.passwordInput.input.nativeElement.type = "password";
      this.isPasswordVisible = false;
      this.passwordicon = 'textbox-hidden';
    }
  }

  showPasswordRe() {
    if (this.passwordInputRe) {
      this.passwordInputRe.input.nativeElement.type = "text";
      this.isPasswordRewriteVisible = true;
      this.passwordicon = 'password';

    }
  }

  hidePasswordRe() {
    if (this.passwordInputRe) {
      this.passwordInputRe.input.nativeElement.type = "password";
      this.isPasswordRewriteVisible = false;
      this.passwordicon = 'textbox-hidden';

    }
  }
}
